import React from "react";

const Bash_Ping = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Ping</h2>
      <p>Test network connectivity to a host.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>ping [options] host</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>ping -c 4 google.com
ping 8.8.8.8</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -c to limit the number of packets.</p>
    </div>
  );
};

export default Bash_Ping;
